import React from "react";
import { useAppSelector } from "../../store/hooks";
import SuspenceLoader from "../suspence";

const GlobalLoader: React.FC = () => {
  const { loading } = useAppSelector((state) => state.loading);

  if (!loading) return null;

  return <SuspenceLoader />;
};

export default GlobalLoader;
